<!-- eslint-disable vue/multi-word-component-names -->

<script setup>
import { defineEmits } from "vue";

import ProductsCard from "./ProductCard.vue";

const emit = defineEmits(['change_component']);

function change_page(name) {
  emit("change_component",name)
}

</script>

<template>
  <main class="w-full h-auto my-2">
    <section class="container mx-auto h-auto flex flex-col justify-start items-center">
      <span class="font-bold text-xl">Products</span>

      <section class="w-11/12 h-auto  grid grid-cols-1 md:grid-cols-3 gap-2 box-border p-2">
        <ProductsCard @click="change_page('VascularProducts')" title="Vascular Products"></ProductsCard>
        <ProductsCard @click="change_page('Angiography')" title="Angiography"></ProductsCard>
        <ProductsCard @click="change_page('Urology')" title="Urology"></ProductsCard>
        <ProductsCard @click="change_page('Oncology')" title="Oncology"></ProductsCard>
        <ProductsCard @click="change_page('HospitalProducts')" title="Hospital Products"></ProductsCard>
        <ProductsCard @click="change_page('SpecializedHospital')" title="Specialized Hospital Antibacterial Anti Fungal Solutions"></ProductsCard>
        <ProductsCard @click="change_page('generalsurgery')" title="General Surgery"></ProductsCard>
        <ProductsCard @click="change_page('cosmetics')" title="Cosmetics"></ProductsCard>
        <ProductsCard @click="change_page('ophtalmology')" title="Ophtalmology"></ProductsCard>
      </section>

      <a download href="/katalog.pdf" class="w-11/12 h-[30px] bg-green-400 rounded-md flex justify-center items-center"> Download Katalog </a>


    </section>
  </main>
</template>

<style scoped></style>
